import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { TeamDTO } from '@atlassiansox/phobos-client-ts';

import { subStringBetween } from '@/utils';

import useOrgUserController from './org-user-controller';

const useLocationController = () => {
  const { teams: orgUserTeams } = useOrgUserController();
  const location = useLocation();
  const isSearchPage = location.pathname === '/search';
  const isTeamPage = location.pathname.startsWith('/team/');
  const isTeamPageCapabilitiesTab =
    isTeamPage &&
    !location.pathname.includes('/products') &&
    !location.pathname.includes('/history');
  const isDashboard = location.pathname.includes('/dashboard');
  const isProductPage = location.pathname.startsWith('/product/');
  const isProductPageCapabilitiesTab =
    isProductPage &&
    !location.pathname.includes('/teams') &&
    !location.pathname.includes('/history');
  const isHomepage = useMemo(() => {
    if (location.pathname === '/') {
      return true;
    }

    if (!isDashboard || !isTeamPage || !orgUserTeams) {
      return false;
    }

    const currentTeamId: string = subStringBetween(location.pathname, '/team/', '/dashboard');
    return (
      orgUserTeams.length === 1 &&
      orgUserTeams.some((orgUserTeam: TeamDTO) => orgUserTeam.publicId === currentTeamId)
    );
  }, [orgUserTeams, isDashboard, isTeamPage, location.pathname]);
  const isSLOPage = location.pathname.startsWith('/slo/');
  const isSLOGroupMemberPage =
    (location.pathname.includes(':') || location.pathname.includes('%3A')) &&
    location.pathname.startsWith('/slo/');
  const isSLOGroupPage =
    location.pathname.startsWith('/slo-group/') || location.pathname.startsWith('/slo-mimir/');
  const isSimulateAlertPage = location.pathname.startsWith('/simulate');

  return {
    isSLOPage,
    isSearchPage,
    isHomepage,
    isTeamPage,
    isTeamPageCapabilitiesTab,
    isDashboard,
    isProductPage,
    isProductPageCapabilitiesTab,
    isSLOGroupPage,
    isSLOGroupMemberPage,
    isSimulateAlertPage,
  };
};

export default useLocationController;
